<!--/*
 * Copyright (c) 2020 The Awareness Company. All rights reserved. 
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */ -->
<template>
  <apexchart type="line" height="310" :options="chartOptions" :series="series" />
</template>

<script>
export default {
  name: "Peaks",
  data: () => ({
    series: [
      {
        name: "series1",
        type: "line",
        data: []
      }
    ],
    chartOptions: {
      theme: {
        mode: "dark",
        palette: "palette10"
      },
      colors: ["#008FFB", "#4CAF50", "#e91e63", "#F86624"],
      chart: {
        background: "rgb(28, 42, 82)",
        foreColor: "rgb(212, 212, 212)",
        toolbar: {
          show: true,
          tools: {
            download: false,
            selection: false
          },
          autoSelected: "zoom"
        }
      },
      grid: {
        borderColor: "rgb(27, 36, 77)"
      },
      stroke: {
          curve: 'smooth'
        },
      legend: {
        show: true,
        position: "bottom",
        itemMargin: {
          vertical: 10
        }
      },
      markers: {
        size: 0
      },
      xaxis: {
        type: "datetime",
        labels: {
          style: {
            fontSize: "10px"
          }
        }
      },
      tooltip: {
        x: {
          show: true,
          format: "dd MMM"
        }
      }
    }
  }),
  methods: {
    loadCases(data, countryDisplay) {
      this.series[0].data = [];
      var ser = [
        { name: "Change in cases", data: [],type: "line", }
      ];

      //first loop through each country and concat the cases data to find the distinct dates
      var allcases = []
      for (var j = 0; j < data.length; j++) {
        allcases = allcases.concat(data[j].cases)
      }

      //sort by date
      allcases = allcases.sort(function(a, b) {
        a = a.date;
        b = b.date;
        return a < b ? -1 : a > b ? 1 : 0;
      });

      //then get all the distinct dates
      var dates = [];
      dates = Array.from(new Set(allcases.map(cas => this.$moment(cas.date, "YYYY-MM-DD").endOf('month').format("YYYY-MM-DD")))).map(date => {
        return date;
      });

      //remove the last date
      dates = dates.splice(0,dates.length -1)

      //loop through dates and get daily confirmed
      var vals = []
      var peaks = []
      var peakstartdate = null
      var peakenddate = null
      var maxdelta = 0
      var maxdate = null 
      var maxindex = -1

      //loop through all the dates and find cases
      for (var i = 0; i < dates.length; i++) {
        var thisDate = dates[i];

        //filter the matching dates from all cases
        var cdat = allcases.filter(c => c.date === thisDate)

        //CONFIRMED
        var confirmed = cdat.reduce(function(prev, cur) {
          return prev + cur.cumulative_cases;
        }, 0);
        
        //find previous cumulative count
        var prevInd = i - 1
        var prevprevInd = i - 2

        if(prevprevInd >= 0) {
          var prevDate = dates[prevInd]
          var prevprevDate = dates[prevprevInd]

          //filter the matching dates from all cases
          var prevcdat = allcases.filter(c => c.date === prevDate)
          var prevprevcdat = allcases.filter(c => c.date === prevprevDate)

          //CONFIRMED
          var prevconfirmed = prevcdat.reduce(function(prev, cur) {
            return prev + cur.cumulative_cases;
          }, 0);

          var prevprevconfirmed = prevprevcdat.reduce(function(prev, cur) {
            return prev + cur.cumulative_cases;
          }, 0);

          var diff = confirmed - prevconfirmed
          var prevdiff = prevconfirmed - prevprevconfirmed

          var delta = diff - prevdiff

          //check the peak
          if(delta > maxdelta) {
            maxdelta = delta
            maxdate = thisDate
          }

          //push to array
          ser[0].data.push([
            this.$moment(thisDate, "YYYY-MM-DD")
              .add(10, "hours")
              .toDate(),
            delta
          ]);
        }    
      }

      //set the graph data
      this.series = ser;

      //find max index
      for (let i = 0; i < ser[0].data.length; i++) {
        let arr = ser[0].data[i]
        let arrDate = this.$moment(arr[0]);
        let maxDate = this.$moment(maxdate, "YYYY-MM-DD").add(10, "hours");
        if(arrDate.isSame(maxDate)) {
          maxindex = i
        }
      }

      //create annotations loop backwards from peak to find >50% increase
      for(var i = maxindex; i > 0; i--) {
        //calc the pec
        var perc = 0
        var tVal = ser[0].data[i][1]
        var pVal = ser[0].data[i-1][1]

        if(tVal < 0) {
          peakstartdate = ser[0].data[i][0]
          break
        }

        if(pVal > 0) {
          perc = (tVal/pVal)*100
          perc = parseFloat(perc.toFixed(2))
        }

        //more than doubled
        if(perc >= 200) {
          peakstartdate = ser[0].data[i][0]
        }
      }

      //loop forward to find the end
      for(var i = maxindex; i < ser[0].data.length; i++) {
        var tVal = ser[0].data[i][1]
        if(tVal < 0) {
          peakenddate = ser[0].data[i][0]
          break
        }
      }

      peaks.push({peak: maxdate, peakstart: peakstartdate, peakend: peakenddate})

      var annots = []
      for (var i = 0; i < peaks.length; i++) {

        //peak
        //calculate the time between start and peak
        var ptext = "Peaked"
        if(peaks[i].peak && peaks[i].peakstart) {
          var a = this.$moment(peaks[i].peak, "YYYY-MM-DD")
          var b = this.$moment(peaks[i].peakstart, "YYYY-MM-DD")
          var diff = a.diff(b, 'months') + 1
          ptext += " after " + diff + " months"
        }

        annots.push({
            x: this.$moment(peaks[i].peak, "YYYY-MM-DD").add(10, "hours").toDate().getTime(),
            fillColor: '#d81b60',
            opacity: 0.4,
            label: {
              //orientation: "horizontal",
              borderColor: '#d81b60',
              style: {
                fontSize: '12px',
                color: '#fff',
                background: '#d81b60',
              }, 
              offsetY: -10,
              text: ptext,
            }
          })

          //start
          annots.push({
            x: this.$moment(peaks[i].peakstart, "YYYY-MM-DD").add(10, "hours").toDate().getTime(),
            fillColor: '#ab47bc',
            opacity: 0.4,
            label: {
              //orientation: "horizontal",
              borderColor: '#ab47bc',
              style: {
                fontSize: '12px',
                color: '#fff',
                background: '#ab47bc',
              },
              offsetY: -10,
              text: 'Peak started',
            }
          })

          //end
          if(peaks[i].peakend) {

            //calculate the time between peak and end
            var etext = "Peak ended"
            if(peaks[i].peak && peaks[i].peakend) {
              var a = this.$moment(peaks[i].peakend, "YYYY-MM-DD")
              var b = this.$moment(peaks[i].peak, "YYYY-MM-DD")
              var diff = a.diff(b, 'months')
              if(diff === 0) {
                diff = 1
              }
              etext += " after " + diff + " months"
            }

            annots.push({
              x: this.$moment(peaks[i].peakend, "YYYY-MM-DD").add(10, "hours").toDate().getTime(),
              fillColor: '#ab47bc',
              opacity: 0.4,
              label: {
                //orientation: "horizontal",
                borderColor: '#ab47bc',
                style: {
                  fontSize: '12px',
                  color: '#fff',
                  background: '#ab47bc',
                },
                offsetY: -10,
                text: etext,
              }
            })
          }
      }

      this.chartOptions = {
        ...this.chartOptions,
        ...{
          annotations: {
            xaxis: annots
          }
        }
      };

    },
    resize() {
      let self = this;
      this.$nextTick().then(function() {
        self.chartOptions = {
          chart: {
            height: "310"
          }
        };
      });
    }
  }
};
</script>
